import 'script!rp-diffusion-connector/dist/rpdiffusion.min.js';

import * as rpGuiGuide from 'rp-gui-guide';
import * as SegmentIO from 'rp-analytics';
import rpPopup from 'rp-popup';
import { cleanLegacy } from 'rp-cookie';
import initNavigationPrefs from 'rp-url-navigation-prefs';
import rpAdvertising from 'rp-advertising';
import analyticsPage from './analyticsPage';

import 'rp-gui-guide/dist/css/rpguiguide.min.css';
import 'rp-advertising/dist/rpadvertising.min.css';
import 'rp-jquery-select/dist/rpjqueryselect.min.css';

import '../css/main.scss';

cleanLegacy();
rpGuiGuide.default({
    svg: { polyfill: true }
});
rpGuiGuide.tabs();
rpGuiGuide.accordions();
rpPopup();
initNavigationPrefs();
analyticsPage();

window.SegmentIO = SegmentIO;

rpAdvertising();



// WEBPACK FOOTER //
// ./src/js/imports.js